import { render, staticRenderFns } from "./IndicatorCards.vue?vue&type=template&id=6494dded&scoped=true"
import script from "./IndicatorCards.vue?vue&type=script&lang=ts"
export * from "./IndicatorCards.vue?vue&type=script&lang=ts"
import style0 from "./IndicatorCards.vue?vue&type=style&index=0&id=6494dded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6494dded",
  null
  
)

export default component.exports